export function getFormattedDate(dateString: string | undefined): string | undefined {
    if (!dateString) {
        return dateString;
    }

    // An alternate solution is to use formatDate provided in owa-datetime-formatters-
    // https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web?path=/shared/internal/owa-datetime-formatters/src/docs/formatDate.md
    const tIndex = dateString.indexOf('T');
    if (tIndex !== -1) {
        return dateString.substring(0, tIndex);
    }

    return dateString;
}

export default getFormattedDate;
